import FieldValidator from './_FieldValidator';

export default class BriteVerifyFieldValidator extends FieldValidator {
    constructor() {
        super('Please enter a valid email address');
    }

    async validate(value) {
        const uri = `/umbraco/rhythm/briteverifyapi/Verify?email=${encodeURIComponent(value)}`;
        const request = {
            method: 'GET'
        };
        return await fetch(uri, request).then(async (response) => {
            const body = await response.json();

            return Promise.resolve({ valid: body, messages: [{ text: this.message }] });
        }, () => {
            return Promise.resolve({ valid: false, messages: [{ text: this.message }] });
        });
    }
}